import styles from "./InfoListItem.module.css";
import { useMemo } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import "dayjs/locale/es";
import config from "environment";
import { useTranslation } from "react-i18next";

/**
 * List item displaying a title, date and text content in the Prospecting Info section.
 * Used under Notes and History headers.
 */
export function InfoListItem({ title, date, content }) {

  const {t, i18n} = useTranslation();

  const { datetime, formatted } = useMemo(() => {
    const locale = i18n.language || "en";
    dayjs.locale(locale);

    return {
      datetime: dayjs(date).toISOString(),
      formatted: dayjs(date).format(config.dateTimeFormat),
    };
  }, [date, i18n.language]);

  return (
    <div className={styles.container}>
      <h5 className={styles.header}>{t(title)}</h5>
      <time className={styles.timestamp} dateTime={datetime}>
        {formatted}
      </time>
      <div className={styles.content}>{content}</div>
    </div>
  );
}

InfoListItem.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
    .isRequired,
  content: PropTypes.string,
};
